import { SecondaryButton, DangerButton } from "@graffer-inc/console-design-kit";
import { TaskSummary } from "../../../../../application/domain/application/application-removal-task/create-task-result";
import { useConfirmApplicationRemovalTaskRegister } from "./hook";
import { DetailField } from "../../../../molecules/application-removal-task/application-removal-task-detail-field";
import { ApplicationRemovalTaskCheck } from "../../../../molecules/application-removal-task/application-removal-task-check";
import {
  formatDatetime,
  formatOnlyDate,
} from "../../../../../utils/date-utils";

type ConfirmApplicationRemovalTaskRegisterProps = {
  taskSummary: TaskSummary;
  targetProcedureName: string;
  reason: string;
  removeDate: Date;
  onCancel: () => void;
  onSubmit: () => void;
};

export const ConfirmApplicationRemovalTaskRegister: React.FC<
  ConfirmApplicationRemovalTaskRegisterProps
> = ({
  taskSummary,
  targetProcedureName,
  reason,
  removeDate,
  onCancel,
  onSubmit,
}) => {
  const {
    checkboxItems,
    setCheckBasicInfo,
    setCheckRemoveDate,
    setCheckWithinOneYear,
    removeDateWithinSevenDays,
    latestCreatedAtWithinOneYear,
    disableSubmitButton,
  } = useConfirmApplicationRemovalTaskRegister(
    taskSummary.latestCreatedAt,
    removeDate,
  );

  return (
    <>
      <div className="notification is-danger is-light has-text-weight-bold mb-2">
        <div>
          選択された申請をデータベースから削除します。削除後に復元することはできません。
        </div>
        <div>
          以下の内容をよく確認し、問題がない場合は「申請削除タスクを登録する」ボタンを押してください。
        </div>
      </div>
      <dl className="my-5">
        <DetailField label="削除対象の申請が紐づく手続き" labelWidth="250px">
          {targetProcedureName}
        </DetailField>
        <DetailField label="削除件数" labelWidth="250px">
          {taskSummary.targetApplicationsCount}件
        </DetailField>
        <DetailField label="削除理由" labelWidth="250px">
          {reason}
        </DetailField>
        <DetailField label="削除対象の申請日時" labelWidth="250px">
          {formatDatetime(taskSummary.earliestCreatedAt)}
          {" ~ "}
          {formatDatetime(taskSummary.latestCreatedAt)}
        </DetailField>
        <DetailField label="削除予定日" labelWidth="250px">
          {formatOnlyDate(removeDate)}
        </DetailField>
      </dl>
      <ApplicationRemovalTaskCheck
        title="申請削除の注意事項"
        checkboxLabel="上記の内容を確認しました。"
        description={
          <>
            <div>
              削除予定日以降に順次削除を行います。一度削除された申請データは復旧できません。
            </div>
          </>
        }
        value={checkboxItems.basicInfo}
        onChange={setCheckBasicInfo}
      />
      {removeDateWithinSevenDays && (
        <ApplicationRemovalTaskCheck
          title="削除予定日に対する確認"
          checkboxLabel="上記の内容を確認しました。"
          description={
            <>
              <div>
                削除予定日は期間に猶予を持った日付を推奨していますが、削除予定日が本日から7日以内に設定されています。
              </div>
            </>
          }
          value={checkboxItems.removeDate}
          onChange={setCheckRemoveDate}
        />
      )}
      {latestCreatedAtWithinOneYear && (
        <ApplicationRemovalTaskCheck
          title="削除対象の申請に対する確認"
          checkboxLabel="上記の内容を確認しました。"
          description={
            <>
              <div>
                削除対象の申請に、1年以内に作成された申請が含まれています。
              </div>
            </>
          }
          value={checkboxItems.withinOneYear}
          onChange={setCheckWithinOneYear}
        />
      )}
      <div className="mt-3 columns">
        <div className="column is-narrow">
          <SecondaryButton
            key={"select-file"}
            text={"ファイルの選択に戻る"}
            onClick={onCancel}
          />
        </div>
        <div className="column is-narrow">
          <DangerButton
            key={"submit"}
            text={"申請削除タスクを登録する"}
            onClick={onSubmit}
            disabled={disableSubmitButton}
          />
        </div>
      </div>
    </>
  );
};
